import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import logo from "../assets/uzpln-logo.png";
import aircraft from "../assets/aircraft.png";
import LanguageSelector from "./LanguageSelector";

export const Header: React.FC = () => {
  return (
    <Container>
      <Grid container={true} spacing={0}>
        <Grid item={true}>
          <a href="https://uzpln.cz">
            <img src={logo} alt="UZPLN/AAII logo" />
          </a>
        </Grid>
        <Grid item={true} md={5} sm={8} xs={7} sx={{ color: "#cb993b" }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: "22px",
              fontWeight: "bold",
              lineHeight: "34px",
              marginTop: "20px",
              marginBottom: "10px"
            }}
          >
            ÚSTAV PRO ODBORNÉ ZJIŠŤOVÁNÍ PŘÍČIN LETECKÝCH NEHOD
          </Typography>
          <Typography variant="h5" sx={{ fontSize: "14px", fontWeight: "bold", marginY: "10px" }}>
            AIR ACCIDENTS INVESTIGATION INSTITUTE
          </Typography>
        </Grid>
        <Grid item={true}>
          <img src={aircraft} alt="Letadlo/Aircraft" style={{ height: "140px" }} />
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <LanguageSelector />
      </Box>
    </Container>
  );
};
